import { Box, Checkbox, Divider, SxProps, TableCell, TableCellProps, TableHead, TableRow, Theme } from "@mui/material";
import { ElementType, MouseEventHandler } from "react";
import { twMerge } from "tailwind-merge";

interface HeaderProps extends TableCellProps {
    header: { 
        value: string; 
        class: string;
        checkbox?: boolean;
        checked?: boolean;
        onChange?: () => {}
    }[]
    className?: string
    icon?: ElementType
    sxProps?: SxProps<Theme>
    colorProp?: string
    sizeProp?: string
    textClass?: string
    actionCell?: MouseEventHandler<HTMLTableRowElement>
}

export default function Header({ header, className, icon: Icon, sxProps, colorProp, sizeProp, actionCell, textClass, ...rest }: HeaderProps) {
    return (
        <TableHead>
            <TableRow
                // className={twMerge("bg-[#E2E2E2] h-[32px]", className)}
                className={twMerge("tw-h-[32px]", className)}
                onClick={actionCell}
            >
                {header.map((head:any) => (
                    <TableCell 
                        key={head.value} 
                        colSpan={head.span || 1}
                        className={twMerge("tw-h-[32px]", head.class)} 
                        align="center" 
                        style={{
                            // borderBottom: 0
                        }}
                        sx={{ 
                            borderBottom: '1px solid #E2E2E2',
                            '&.MuiTableCell-root': {
                                padding: '0 4px',
                                textAlign: 'left',
                            }
                        }} 
                        {...rest}
                    >
                        <Box className="tw-bg-[#fff] tw-px-2 tw-py-1 tw-rounded tw-h-full tw-flex tw-text-azulescuro tw-items-center">
                            {Icon ? <Icon sx={sxProps} color={colorProp} fontSize={sizeProp} /> : ''}
                            {head.value && (<span className={twMerge("text-[#fff] font-semibold", textClass)}>{head.value}</span>)}

                            {head.checkbox && (
                                <Checkbox 
                                    onChange={(e) => { 
                                        head.onChange()
                                    }}
                                    checked={head.checked} 
                                    className="tw-w-full"
                                    style={{
                                        padding: '0',
                                    }}
                                />
                            )}
                        </Box>
                        
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}
